export default __webpack_public_path__ + "static/media/IMG_0012_3_11zon.cddab0bb.jpg";